import { PageType } from "shared/lib/page-type";

export const pathname = "/games/mini-sudoku/archive";

export const page = {
  route(query: QueryParameters) {
    return { pathname, query: { ...query, pageType: PageType.GamesMiniSudoku } };
  },
};
